// src/components/store/sections/product-cards/Variant95BentoModularEmeraldMintCard.tsx
"use client";

import Image from "next/image";
import Link from "next/link";
import { Star, ShoppingCart, Flame, Check } from "lucide-react";
import { UniversalProductCardProps, useCardActions } from "./useCardActions";

export default function Variant95BentoModularEmeraldMintCard({
  product,
  subdomain = "nextlook",
}: UniversalProductCardProps) {
  const {
    productImg,
    productName,
    productUrl,
    categoryName,
    rating,
    currentPrice,
    discountPercent,
    added,
    handleAddToCart,
  } = useCardActions(product, subdomain);

  return (
    <div className="w-full h-full bg-emerald-50 rounded-[28px] p-2.5 border-2 border-emerald-200 shadow-sm hover:shadow-xl transition-all flex flex-col justify-between gap-2 group select-none">
      <div className="grid grid-cols-12 gap-2">
        <Link href={productUrl} className="col-span-8 relative h-40 rounded-2xl bg-white border border-emerald-200 flex items-center justify-center p-2 overflow-hidden">
          <Image src={productImg} alt={productName} fill unoptimized className="object-contain p-2 group-hover:scale-110 transition-transform" />
        </Link>
        <div className="col-span-4 flex flex-col gap-2">
          <div className="flex-1 rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 text-white p-2 flex flex-col items-center justify-center text-center shadow-xs">
            <Flame className="w-3.5 h-3.5 fill-current mb-0.5" />
            <span className="text-xs font-black leading-none">-{discountPercent}%</span>
          </div>
          <div className="flex-1 rounded-2xl bg-white border border-emerald-200 p-2 flex flex-col items-center justify-center text-center">
            <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400 mb-0.5" />
            <span className="text-xs font-black text-slate-800 leading-none">{rating.toFixed(1)}</span>
          </div>
        </div>
      </div>

      <div className="rounded-2xl bg-white border border-emerald-200 p-3">
        <span className="text-[9px] font-black uppercase tracking-wider text-emerald-700 block truncate">{categoryName}</span>
        <Link href={productUrl} className="block mt-0.5">
          <h3 className="text-xs sm:text-sm font-black text-slate-900 truncate hover:underline">{productName}</h3>
        </Link>
      </div>

      <div className="rounded-2xl bg-slate-900 text-white p-3 flex items-center justify-between gap-2">
        <span className="text-base font-black font-mono">৳{currentPrice.toLocaleString()}</span>
        <button
          type="button"
          onClick={(e) => handleAddToCart(e)}
          className="px-3.5 py-1.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-black text-[10px] uppercase tracking-wider cursor-pointer active:scale-95 transition-all flex items-center gap-1"
        >
          {added ? <Check className="w-3.5 h-3.5" /> : <ShoppingCart className="w-3.5 h-3.5" />}
          <span>{added ? "Added" : "Add"}</span>
        </button>
      </div>
    </div>
  );
}
